export const hotelRegulationsText = {
"en-US": `
<p><b>Dear Guest,</b></p>

<p>We’re thrilled to have you stay with us at <b>THE MYDE</b>, where we strive to create a <b>cozy, fun, and safe</b> environment for all our guests. To help us maintain this atmosphere, we kindly ask that <b>you follow the house rules</b> outlined below. These guidelines ensure <b>everyone’s comfort, safety, and enjoyment</b>, while also helping us preserve the quality of our property.</p>

<p><b>House Rules:</b></p>

<p><b>1. Security Deposit:</b><br>
A <b>security deposit of EUR 1</b> is required for every reservation. This deposit will be held on your credit card and <b>released within one week after checkout</b>, provided there are no damages or issues.</p>

<p><b>2. Self-Check-In:</b><br>
THE MYDE operates with a <b>self-check-in system</b>. To access your room, please complete the <b>Self-Check-In Form</b> sent with your booking confirmation and ensure that your <b>payment is processed</b>. <b>We are not responsible for any access issues</b> if these steps are not completed.</p>

<p><b>3. Communication & Services:</b><br>
All communication, <b>except in emergencies</b>, should be conducted <b>through our guest portal or by WhatsApp</b>. Rooms are <b>cleaned and prepared before your arrival</b>, but the <b>room rate does not include cleaning services during your stay</b>. For stays of 6 nights or more, the rooms are cleaned weekly and include fresh towels and bed linen. You are welcome to request an intermediate cleaning at any time for a fee of <b>EUR 50,-</b>.</p>

<p><b>4. No Parties or Events:</b><br>
THE MYDE is a <b>social yet peaceful</b> place. <b>Parties and events that cause noise or disturbances are strictly prohibited</b> to maintain a pleasant environment for all guests.</p>

<p><b>5. No Smoking:</b><br>
Smoking is <b>prohibited indoors</b>. <b>Any violation will be charged with EUR 80,-</b>. Please use the designated outdoor smoking areas and dispose of cigarette butts responsibly. The hotel assumes no liability for unauthorized smoking that triggers a fire alarm due to tampered smoke detectors. The resulting costs are the responsibility of the party responsible.</p>

<p><b>6. No Pets:</b><br>
Although we love animals, <b>THE MYDE is a pet-free property</b> to ensure a <b>clean and allergen-free</b> environment for all guests.</p>

<p><b>7. Found Items:</b><br>
If you <b>leave anything behind</b>, it will be kept in our <b>lost and found</b>. Please contact us to arrange a collection, as our office may not always be open.</p>

<p><b>8. No Unregistered Guests:</b><br>
For <b>security and comfort</b>, only guests listed in the booking are allowed on the premises.</p>

<p><b>9. Quiet Hours:</b><br>
To ensure a <b>restful environment</b>, quiet hours are:</p>
<p>• <b>10:00 PM – 7:00 AM</b><br>
• <b>Sundays and public holidays</b> are also considered <b>quiet times</b>.</p>

<p><b>10. Check-In and Check-Out Times:</b><br>
Please <b>respect our check-in and check-out times</b> to help us manage cleaning schedules and prepare for incoming guests.</p>

<p><b>11. Key Care:</b><br>
Please take care of your room key. <b>Lost keys will incur a replacement fee of EUR 5,-</b>.</p>

<p><b>12. Respect for Furniture and Property:</b><br>
<b>Treat the property with care</b> and report any damages. If damages <b>exceed the security deposit</b>, additional charges will apply.</p>

<p><b>13. No Rearranging Furniture:</b><br>
Please <b>do not move or rearrange furniture</b>, as this can cause damage and create extra work for our team.</p>

<p><b>14. Dishes:</b><br>
We kindly ask that you <b>wash your dishes before departure</b> to help us maintain a clean and ready space for the next guest.</p>

<p><b>15. No Illegal Substances:</b><br>
The <b>use or possession of illegal substances is strictly forbidden</b> to ensure a safe and legal environment for all guests.</p>

<p><b>16. No Prostitution:</b>

<b>Prostitution is strictly prohibited</b> at THE MYDE. <b>Violation of this rule will result in a EUR 1.000,- fine and a report to the authorities.</b></p>

<p><b>17. Room cleaning:</b><br>
Room cleaning is included in the room rate. However, the hotel reserves the right to charge a special cleaning fee of EUR 75,- for serious or unusual soiling and significantly higher cleaning requirements.</p>

<p>By following these rules, you’re helping us keep <b>THE MYDE a welcoming, enjoyable, and safe</b> place for everyone. We <b>appreciate your cooperation</b> and hope you have a <b>fantastic stay!</b></p>

<p><b>Warm regards,
THE MYDE Team</b></p>
`};
